import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { routes } from "../../../routes.ts";
import { useRecipe } from "../RecipeContext.tsx";

export const CancelEditButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { recipe } = useRecipe();

  if (!recipe.hasPublishedVersion) return null;

  return (
    <Button
      icon={<CloseOutlined />}
      onClick={() => void navigate({ pathname: routes.recipeDetail.to(recipe.id), hash: location.hash })}
    >
      {t("common.cancel")}
    </Button>
  );
};
